<template>
  <div class="footer">
    <div class="wrap">
      <!-- Maps -->
      <div class="map"></div>
      <div class="text">
        <h2>
          Contacts
        </h2>
        <ul>
          <li>
            <i class="fab fa-instagram"></i> <a href="#">Instagram</a>
          </li>
          <li>
            <i class="fas fa-map-marked-alt"></i> <a href="#">Google Maps</a>
          </li>
          <li>
            <i class="fab fa-google-plus-g"></i> <a href="#">Google Plus</a>
          </li>
          <li>
            <i class="far fa-envelope"></i> <a href="#">Gmail</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import Parallax from "vue-parallaxy";

  export default {
    name: 'Footer',

    components: {
      Parallax
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../assets/styles/variables.scss";

  .footer{
    width: 100%;
    height: auto;
    float: left;
    overflow: hidden !important;
    position: relative;
    background-color: #212121;
    padding-top: 50px;
    padding-bottom: 50px;

    @media screen and (max-width: 768px) {
      height: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }

    .wrap{
      position: relative;

      .text{
        width: 40%;
        height: 350px;
        position: relative;
        left: 0;
        display: -webkit-flex;
        display: -moz-flex;
        display: -ms-flex;
        display: -o-flex;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        float: left;

        @media screen and (max-width: 768px) {
          height: auto;
          padding: 40px 0;
          width: 100%;
          align-items: center;
        }

        h2{
          display: inline-block;
          text-align: right;
          border-bottom: 2px solid $accentColor;
          font-weight: 400;
          color: #fff;

          @media screen and (max-width: 768px) {
            text-align: center;
          }
        }

        ul{
          width: 70%;
          text-align: left;
          margin-left: 15%;
          margin-top: 18px;

          @media screen and (max-width: 768px){
            text-align: center;
            width: 100%;
            margin-left: 0;
          }

          li{
            height: 30px;
            line-height: 30px;
            font-size: 17px;
            list-style: none;

            a{
              color: #fff;
            }

            i{
              color: #fff;
              margin-right: 17px;
              width: 17px;
            }
          }
        }
      }
      
      .map{
        width: 50%;
        position: relative;
        right: 0;
        height: 350px;
        background-color: #f7f7f7;
        float: right;

        @media screen and (max-width: 768px) {
          overflow: hidden;
          position: relative;
          width: 100%;
        }
      }
    }
  }
</style>
